const ADMIN_AUTH_ID = import.meta.env.VITE_ADMIN_AUTH_ID as string | undefined;
const CLERK_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

/**
 * Non-hook admin check for use outside React components (e.g. route beforeLoad).
 * In dev mode (no Clerk), returns true.
 */
export function isAdminAuthId(clerkUserId: string | undefined): boolean {
  if (!CLERK_KEY) return true;
  if (!ADMIN_AUTH_ID || !clerkUserId) return false;
  return clerkUserId === ADMIN_AUTH_ID;
}
